var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightType2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color: "#12385C"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.012 5.663A.922.922 0 016.95 6a.811.811 0 01-.187.288l-4.5 4.5a.72.72 0 01-.525.225.72.72 0 01-.525-.225.72.72 0 01-.225-.525c0-.2.075-.375.225-.525l4.075-4.075-4.075-4.075a.72.72 0 01-.225-.525c0-.2.075-.375.225-.525a.72.72 0 01.525-.225c.2 0 .375.075.525.225l4.5 4.5a.813.813 0 01.187.287.93.93 0 01.063.338z",
    fill: "currentColor"
  })));
}
export default SvgArrowRightType2;